import React from 'react';
import colorConfigs from '../../configs/colorConfigs';

interface CustomSVGProps {
  strokeColor?: string; // Optional prop for stroke color
  strokeWidth?: number; // Optional prop for stroke width
  style?: React.CSSProperties; // Optional prop for additional styles
}

const CustomSVG: React.FC<CustomSVGProps> = ({
  strokeColor = colorConfigs.primary,
  strokeWidth = 1,   
  style = {},
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 85.96 14.16"
      preserveAspectRatio="none"
      style={{ width: '100%', height: '40px', position: 'absolute', ...style }}
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="ARTWORK">
          <path
            fill="none"
            stroke={strokeColor} 
            strokeWidth={strokeWidth}
            strokeLinejoin="bevel"
            d="M72.44,3.93A225,225,0,0,0,12.22,1.47c-3.45.31-14.33,1.61-11.14,6,4.53,6.28,42.39,6.76,61.15,5.72,18.13-1,25.54-4.38,22.6-8.3-2.08-2.78-16.74-4-16.74-4"
          />
        </g>
      </g>
    </svg>
  );
};

export default CustomSVG;
